// import {Box} from "@mui/joy";
import OnlyFansLogo from './OnlyFans_Logo.png'
import './OnlyFans.css'; 


function OnlyFansIcon(){
    return(
        <img 
            className='onlyFansLogo'
            src={OnlyFansLogo} alt='OnlyFans'
        />
    )
}

export default OnlyFansIcon